import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PortalScope } from '../../login/login.component';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'confirm-registration',
    templateUrl: 'confirm-registration.component.html',
    standalone: false
})
export class ConfirmRegistrationComponent implements OnInit, OnDestroy {

  private _portalScopeSubscription: any;

  constructor(
    private readonly _navigationService: NavigationService,
    private readonly _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this._portalScopeSubscription = this._activatedRoute.data.subscribe((data) => {
      const portalScope = data["scope"] as PortalScope;
      this._navigationService.navigateToPath("/confirm-account", true, { goToPortal: portalScope || PortalScope.Borrower });
    });
  }

  ngOnDestroy() {
    this._portalScopeSubscription.unsubscribe();
  }
}
